export default class FInfrastructureType {
  constructor(
    id,
    kode1,
    description,
    fdivisionBean,
    statusActive,
    baseId,
    lang,

    kawasan,
    avatarImage,
    markerImage1,

    created,
    modified,
    modifiedBy
  ) {
    this.id = id;
    this.kode1 = kode1;
    this.description = description;
    this.statusActive = statusActive;
    this.fdivisionBean = fdivisionBean;
    this.baseId = baseId;
    this.lang = lang;

    this.kawasan = kawasan;
    this.avatarImage = avatarImage;
    this.markerImage1 = markerImage1;

    this.created = created;
    this.modified = modified;
    this.modifiedBy = modifiedBy;
  }

}
